import * as React from "react";
import IconButton from "../../components/button/IconButton";
import {Badge, ButtonGroup} from "react-bootstrap";


const columns = (t) => [
    {
        field: "seriesNumber",
        label: t ? t("forms.series_number") : "Numer serii",
        sort: "desc",
        width: 53
    },
    {
        field: "quantity",
        label: t ? t("forms.produced_packages") : "Ilość wyprodukowanych opakowań",
        sort: "desc",
        width: 53
    },
    {
        field: "productionStartDate",
        label: t ? t("common.start_date") : "Początek produkcji",
        sort: "desc",
        width: 53
    },
    {
        field: "productionStartUsername",
        label: t ? t("common.user_started") : "Użytkownik rozpoczął",
        sort: "desc",
        width: 53
    },
    {
        field: "productionEndDate",
        label: t ? t("common.end_date") : "Koniec produkcji",
        sort: "desc",
        width: 53
    },
    {
        field: "productionEndUsername",
        label: t ? t("common.user_finished") : "Użytkownik zakończył",
        sort: "desc",
        width: 53
    },
    {
        field: "productName",
        label: t ? t("forms.product_name") : "Nazwa produktu",
        sort: "desc",
        width: 53
    },
    {
        field: "gmidNumber",
        label: "GMID",
        sort: "desc",
        width: 53
    },
    {
        field: "actions",
        label: t ? t("common.actions") : "Akcje",
        sort: "desc",
        width: 30,
        type: "custom",
        custom: function (column, row, history, reload, setReload, setLoader) {

            return <ButtonGroup>
                <IconButton variant={"outline-primary"}
                            icon={"fa-info-circle"}
                            tooltip={t ? t("tooltips.details") : "Szczegóły"}
                            onClick={() => {
                                history.push("/production/" + row.packingLine.id + "/history/" + row.id);
                            }}

                />
            </ButtonGroup>;
        }

    }
];

export default columns;